// @flow
import * as React from 'react'

type Flex = 'none' | 1 | 2
type AlignSelf = 'auto' | 'flexStart' | 'flexEnd' | 'center' | 'baseline' | 'stretch'

type Props = {
  alignSelf: AlignSelf,
  flex: Flex,
  children: React.Node,
}

export default class GridCell extends React.Component<Props> {
  static defaultProps = {
    alignSelf: 'auto',
    flex: (1: Flex),
  }

  render = () => {
    return <div className={this.className}>{this.props.children}</div>
  }

  get className(): string {
    return [
      'Grid-cell',
      this.alignSelfClassNameModifier,
      this.props.flex === 'none' ? 'Grid-cell--flexNone' : '',
      this.props.flex === 2 ? 'Grid-cell--flex2' : '',
    ].join(' ')
  }

  get alignSelfClassNameModifier(): string {
    switch (this.props.alignSelf) {
      case 'flexStart':
        return 'Grid-cell--alignSelfFlexStart'

      case 'flexEnd':
        return 'Grid-cell--alignSelfFlexEnd'

      case 'center':
        return 'Grid-cell--alignSelfCenter'

      case 'baseline':
        return 'Grid-cell--alignSelfBaseline'

      case 'strecth':
        return 'Grid-cell--alignSelfStretch'

      default:
        return ''
    }
  }
}
